<template>
  <div class="addParentCom">
    <el-button type="text" size="small" @click="showDialog">添加</el-button>
    <el-dialog
      title="添加家长"
      :visible.sync="flag"
      :center="true"
      width="30%"
      :before-close="handleClose"
      :destroy-on-close="true"
    >
      <p class="dialog__content__title">家长信息</p>
      <el-form
        ref="parent"
        :model="parent"
        :rules="parentRules"
        label-width="100px"
      >
        <el-form-item label="家长姓名" required prop="name">
          <el-input
            v-model.trim="parent.name"
            size="small"
            style="width:280px;"
            placeholder="家长姓名"
          />
        </el-form-item>
        <el-form-item label="手机号" required prop="mobile">
          <el-input
            size="small"
            v-model.trim="parent.mobile"
            style="width:280px;"
            placeholder="手机号"
          />
        </el-form-item>
        <el-form-item label="家长角色" required prop="relation">
          <el-select
            v-model="parent.relation"
            size="small"
            style="width:280px;"
            filterable
          >
            <el-option
              v-for="item in relationList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <footer class="dialog__footer" slot="footer">
        <el-row type="flex" justify="end">
          <el-button size="small" @click="hidedialogflag">取消</el-button>
          <el-button size="small" type="primary" @click="Submit('parent')"
            >确定</el-button
          >
        </el-row>
      </footer>
    </el-dialog>
  </div>
</template>
<script>
// import info from "@/mixins/info";
import { studentCheckParent, studentSaveParent } from "@/api/home"

export default {
  name: "addParentCom",
  props: {
    relationList: {
      type: Array
    },
    studentId: {
      type: [Number, String]
    }
  },
  // mixins: [info],

  data() {
    return {
      flag: false,
      parent: {
        id: "",
        name: "",
        mobile: "",
        relation: "",
        schoolId: localStorage.getItem('schoolIds'),
        studentId: this.studentId
      },
      parentRules: {
        mobile: [{ validator: this.checkphone, trigger: "blur" }],
        relation: [
          {
            required: true,
            message: "请务必选择与学生关系",
            trigger: ["blur", "change"]
          }
        ],
        name: [
          {
            required: true,
            message: "家长姓名不能为空",
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },
  methods: {
    checkphone(rule, value, callback) {
      let reg = /^(?:(?:\+|00)86)?1\d{10}$/;
      if (!value) {
        return callback(new Error("手机号码不能为空"));
      } else if (!reg.test(value)) {
        callback(new Error("请填写正确的手机"));
      } else {
        studentCheckParent({ phone: value })
          .then(async () => {
            await callback();
          })
          .catch(error => {
            return callback(new Error(error));
          });
      }
    },
    handleClose(){
      this.flag = false
      this.resetForm('parent')
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    showDialog() {
      this.flag = true;
    },
    hidedialogflag() {
      this.flag = false;
      this.resetForm("parent");
    },
    Submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ApiSaveParent();
        } else {
          this.$message.error("请检查信息是否填写正确");
          return false;
        }
      });
    },
    ApiSaveParent() {
      studentSaveParent({ ...this.parent }).then(() => {
        // this.$message({
        //   type: "success",
        //   message: "添加成功"
        // });
        this.hidedialogflag();
        this.$emit("updateList");
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/school/components/components/addParent.vue